import { Boundaries } from "@planzone/core";
import { accountCreationConfirmationError } from "@planzone/dto";
import { events } from "@planzone/events";
import { createStateReducer } from "../../utils/createStateReducer";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = {
  request: {
    isPending: false,
    isSuccessful: false,
    isFailure: false,
  },
  error: accountCreationConfirmationError,
};

function handleRequest(state: State): State {
  return {
    ...state,
    request: { ...initialState.request, isPending: true },
  };
}

function handleSuccess(state: State): State {
  return {
    ...state,
    request: { ...initialState.request, isSuccessful: true },
  };
}

function handleFailure(
  state: State,
  { error }: Boundaries["confirmAccountCreation"]["failure"],
): State {
  return {
    ...state,
    error,
    request: { ...initialState.request, isFailure: true },
  };
}

const reduceState = createStateReducer(initialState, {
  [events.confirmAccountCreationRequested]: handleRequest,
  [events.confirmAccountCreationSucceeded]: handleSuccess,
  [events.confirmAccountCreationFailed]: handleFailure,
});

export type { State, Selector };

export { reduceState, initialState, createSelector };
